import { render, staticRenderFns } from "./McmHeaderTabs.vue?vue&type=template&id=1870aee8&scoped=true"
import script from "./McmHeaderTabs.ts?vue&type=script&lang=ts&external"
export * from "./McmHeaderTabs.ts?vue&type=script&lang=ts&external"
import style0 from "./McmHeaderTabs.vue?vue&type=style&index=0&id=1870aee8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1870aee8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
import { VTabsSlider } from 'vuetify/lib/components/VTabs';
installComponents(component, {VTab,VTabs,VTabsSlider})
